import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { userGoalService } from "@/services/userGoalService";
import { Loader2 } from "lucide-react";

export function OnboardingGate({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<{ onboardingCompleted: boolean } | null>(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    async function checkStatus() {
      try {
        const res = await userGoalService.getOnboardingStatus();
        setStatus(res);
      } catch {
        setStatus({ onboardingCompleted: true });
      } finally {
        setLoading(false);
      }
    }
    checkStatus();
  }, [location.pathname]);

  if (loading) {
    return (
      <div className="flex min-h-[60vh] w-full max-w-full items-center justify-center px-4">
        <div className="flex max-w-md flex-col items-center text-center animate-in fade-in duration-300">
          <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-purple-100 border-t-purple-600 mb-4" />
          <h3 className="text-sm font-semibold text-slate-600 tracking-wide animate-pulse">
            Preparando sua experiência...
          </h3>
          <p className="mt-2 text-xs text-slate-400 max-w-sm">
            Carregando suas preferências de estudo no TEF Canada Trainer.
          </p>
        </div>
      </div>
    );
  }

  const isOnboardingRoute = location.pathname === "/onboarding";

  if (status?.onboardingCompleted === false && !isOnboardingRoute) {
    return <Navigate to="/onboarding" replace />;
  }

  if (status?.onboardingCompleted === true && isOnboardingRoute) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
